import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { SedeDestinoSelect } from 'sharedComponents/select'

const SedeDestinoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='ESTABLECIMIENTO DESTINO' htmlFor='select-sedeDestino' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idSedeDestino'>
          {({ field }) => (
            <SedeDestinoSelect
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-sedeDestino'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SedeDestinoFormGroup)
